<template>
    <div class="login-container">
        <!-- 登入表單 -->
        <div class="login-backgroud">
            <div class="login-form">
                <div class="logo"></div>
                <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm">
                    <el-form-item prop="account">
                        <el-input v-model.trim="loginForm.account" placeholder="請輸入登入電郵/電話"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model.trim="loginForm.password" placeholder="請輸入登入密碼" show-password @keyup.enter.native="prelogin"></el-input>
                    </el-form-item>
                    <el-form-item class="login-btn">
                        <el-button type="primary" @click="prelogin">登入</el-button>
                        <div class="forget-passwd">
                            <span @click="displayConfirmDialog">忘記密碼</span>
                        </div>
                    </el-form-item>
                    <p class="suggestion">建議使用 Google Chrome 瀏覽器，以獲得最佳瀏覽體驗</p>
                </el-form>
            </div>
        </div>
        <p>© Copyright {{new Date().getFullYear()}} pms.house730.com All Rights Reserved</p>

        <!-- 忘記密碼彈框 - 確認賬號-->
        <el-dialog :title="confirmFormVisible ? '確認賬戶' : verifyFormVisible ? '驗證賬戶' : '重置密碼'" :visible.sync="confirmAcountDialogVisible" class="forget-pwd-dialog" width="600px" top="25vh" :close-on-click-modal="false">
            <!-- 确认账户表单 -->
            <el-form :model="confirmForm" :rules="forgetFormRules" ref="confirmForm" label-width="155px" v-show="confirmFormVisible">
                <el-form-item label="賬戶登入電郵/電話：" prop="account">
                    <el-input v-model="confirmForm.account" placeholder="請輸入登入電郵/電話" class="email-input"></el-input>
                </el-form-item>
                <el-form-item label="驗證碼：" prop="vertifyCode">
                    <el-row>
                        <el-col :span="13">
                            <el-input v-model="confirmForm.vertifyCode" placeholder="請輸入驗證碼" class="vertify-code-input"></el-input>
                        </el-col>
                        <el-col :span="7">
                            <img @click="confirmCodeImgCilck" :src="'data:image/gif;base64,' + confirmForm.verfiyCodeImg" alt="驗證碼" class="code-img" />
                        </el-col>
                    </el-row>
                </el-form-item>
                <div class="tips">如你忘記密碼，請輸入賬戶登入電郵或電話， 我們稍後會把重設密碼的驗證碼傳送給你。</div>
            </el-form>
            <!-- 验证账户表单 -->
            <el-form :model="verifyForm" :rules="forgetFormRules" ref="verifyForm" label-width="155px" v-show="verifyFormVisible">
                <el-form-item label="賬號：" prop="account">
                    <el-input v-model="verifyForm.account" placeholder="請輸入登入電郵/電話" class="email-input" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="驗證碼：" v-if="isShow">
                    <el-row>
                        <el-col :span="13">
                            <el-input v-model="verifyForm.vertifyCode" placeholder="請輸入驗證碼" class="vertify-code-input"></el-input>
                        </el-col>
                        <el-col :span="7">
                            <img @click="vertifyImgCilck" :src="'data:image/gif;base64,' + verifyForm.verfiyCodeImg" alt="驗證碼" class="code-img" />
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="驗證碼：" prop="code">
                    <el-row>
                        <el-col :span="13">
                            <el-input v-model="verifyForm.code" placeholder="請輸入驗證碼" class="vertify-code-input"></el-input>
                        </el-col>
                        <el-col :span="7">
                            <el-button type="primary" @click="getCodeAgain" :disabled="verifyForm.vertifyCode.length === 0 || timeCount >= 0">{{ timeCount < 0 ? '獲取驗證碼' : timeCount }}</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <div class="tips">如你忘記密碼，請輸入賬戶登入電郵或電話， 我們稍後會把重設密碼的驗證碼傳送給你。</div>
            </el-form>
            <!-- 修改密码表单 -->
            <el-form :model="resetPwdForm" :rules="forgetFormRules" ref="resetPwdForm" label-width="155px" v-show="resetPwdFormVisible">
                <el-form-item label="請輸入新密碼：" prop="password">
                    <el-input v-model="resetPwdForm.password" placeholder="請輸入6-20位英文及數字" class="email-input"></el-input>
                </el-form-item>
                <el-form-item label="確認新密碼：" prop="confirmPwd">
                    <el-input v-model="resetPwdForm.confirmPwd" placeholder="請再次輸入新密碼" class="email-input"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="confirmAcountDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAccount" v-if="confirmFormVisible">確認</el-button>
                <el-button type="primary" @click="verifyAccount()" v-if="verifyFormVisible">下一步</el-button>
                <el-button type="primary" @click="resetPwd" v-if="resetPwdFormVisible">確認</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
export default {
    name: 'login',
    data() {
        // 登录校验函数
        let checkAccount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('請填寫電郵/電話'));
            }
            let regEmail = /^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            let regPhone = /^[2-9]\d{7}$/;
            let formatError = !regEmail.test(value.trim()) && !regPhone.test(value);
            if (formatError) {
                return callback(new Error('電郵/電話格式錯誤'));
            } else {
                return callback();
            }
        };
        let checkPass = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('請填寫密碼'));
            } else if (value.toString().length < 6 || value.toString().length > 20) {
                callback(new Error('密碼長度在6-20之間'));
            } else {
                callback();
            }
        };
        let checkCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('驗證碼不能為空'));
            } else {
                return callback();
            }
        };
        let checkComfirmPass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.resetPwdForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            // verfiyCodeImg: "", //校验码图片
            // verfiyCodetoken: "", //校验码token
            timeCount: 120, //倒计时时长
            timeId: null, // 定时器ID
            loginForm: {
                account: '',
                password: ''
            }, // 表单校验数据
            loginFormRules: {
                account: [{ validator: checkAccount, trigger: 'blur' }],
                password: [{ validator: checkPass, trigger: 'blur' }]
            }, // 表单校验规则
            confirmForm: {
                account: '',
                vertifyCode: '',
                verfiyCodeImg: '', //校验码图片
                verfiyCodetoken: '' //校验码token
            }, // 忘记密码弹框
            verifyForm: {
                account: '',
                code: '',
                vertifyCode: '',
                verfiyCodeImg: '', //校验码图片
                verfiyCodetoken: '' //校验码token
            }, // 忘记密码弹框
            isShow: false, //校验弹框--显示校验码输入框
            resetPwdForm: {
                password: '',
                confirmPwd: '',
                token: ''
            }, // 忘记密码弹框
            forgetFormRules: {
                account: [{ validator: checkAccount, trigger: 'blur' }],
                vertifyCode: [{ validator: checkCode, trigger: 'blur' }],
                code: [{ validator: checkCode, trigger: 'blur' }],
                password: [{ validator: checkPass, trigger: 'blur' }],
                confirmPwd: [
                    {
                        validator: checkComfirmPass,
                        trigger: 'blur'
                    }
                ]
            }, //忘记密码表单校验
            confirmAcountDialogVisible: false, // 忘記密碼彈框變量
            verifyAcountDialogVisible: false, //驗證賬戶
            resetPwdDialogVisible: false, //重置密码
            confirmFormVisible: false, // 确认表单显示
            verifyFormVisible: false, // 确认表单显示
            resetPwdFormVisible: false // 确认表单显示
        };
    },
    created() {
        // this.countDown();
    },
    methods: {
        ...mapMutations([
            'setLoginInfo',
            'setUserInfo', // 将 `this.increment()` 映射
            'resetVuex'
        ]),
        // handleSpace(val) {
        //   val = val.trim();
        // },
        // 加载 recaptcha
        async LoadVertifyCode(callback) {
            try {
                let res = await this.axios.get(this.pub.getApi().GetRecaptcha);
                // console.log(res);
                let { code, result } = res.data;
                callback(result);
                // codeImg = result.image;
                // codeToken = result.token;
            } catch (error) {
                console.log(error);
            }
        },
        // 预登錄
        prelogin() {
            this.$refs['loginForm'].validate(async valid => {
                if (valid) {
                    // 预登陆
                    let preRes = await this.axios.post(this.pub.getApi().PreLogin, this.loginForm);
                    // console.log(preRes);
                    let { code, result, message } = preRes.data;
                    // console.log("result", result);
                    if (code === 0) {
                        // 单角色
                        if (result.roleList.length === 1) {
                            // console.log("123456q", result.accountID);
                            // 再次登录
                            this.login({
                                accountID: result.accountID,
                                departmentID: result.roleList[0].accountDepartmentID,
                                password: this.loginForm.password
                            });
                        } else {
                            // 多角色已选择默认角色
                            let isDefault = result.roleList.find(item => {
                                return item.isDefault;
                            });
                            if (isDefault && result.roleList.length > 1) {
                                // 直接登录
                                this.login({
                                    accountID: result.accountID,
                                    departmentID: isDefault.accountDepartmentID,
                                    password: this.loginForm.password,
                                    setDefaultDepartmentID: isDefault.accountDepartmentID
                                });
                            } else {
                                // 多个角色 未选择默认参数
                                this.setLoginInfo(
                                    Object.assign(result, {
                                        password: this.loginForm.password
                                    })
                                );
                                this.setUserInfo({});
                                this.$router.push({
                                    path: '/select-role',
                                    query: {
                                        sorcepath: 'login'
                                    }
                                });
                            }
                        }
                    } else if (code === 1300) {
                        this.$message({
                            message: '登錄電郵/電話與密碼不符，請重新輸入',
                            type: 'error',
                            showClose: true
                        });
                    } else if (code === 1310) {
                        this.$message({
                            message: '您的賬號或密碼輸入有誤已達5次，請十分鐘後再試',
                            type: 'error',
                            showClose: true
                        });
                    } else if (code === 1312) {
                        this.$message({
                            message: '妳的賬戶已被停用，請聯絡客戶服務',
                            type: 'error',
                            showClose: true
                        });
                    } else {
                        this.$message({
                            message: message,
                            type: 'error',
                            showClose: true
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 登录
        async login(data) {
            let res = await this.axios.post(this.pub.getApi().Login, data);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.resetVuex(); // 清楚vuex状态
                this.pub.setCookie('dEVaUDFrZ1kd0RA', result.token);
                // this.setUserInfo({
                //   ...result
                // });

                // 添加登陆标识
                localStorage.setItem('isLoginAgain', 1);
                this.$router.push('/');

                this.$message({
                    message: '登入成功',
                    type: 'success',
                    showClose: true
                });
            } else if (code === 1312) {
                this.$message({
                    message: '妳的賬戶已被停用，請聯絡客戶服務',
                    type: 'error',
                    showClose: true
                });
            } else {
                this.$message({
                    message: message,
                    type: 'error',
                    showClose: true
                });
            }
        },
        //验证用户弹框-- 点击图片获取验证码
        confirmCodeImgCilck() {
            this.LoadVertifyCode(({ image, token }) => {
                this.confirmForm.verfiyCodeImg = image;
                this.confirmForm.verfiyCodetoken = token;
            });
        },
        // 顯示確認彈框
        displayConfirmDialog() {
            this.confirmCodeImgCilck();
            this.confirmAcountDialogVisible = true;

            // 重置表单数据
            this.confirmFormVisible = true;
            this.verifyFormVisible = false;
            this.resetPwdFormVisible = false;
            this.$nextTick(() => {
                this.$refs['confirmForm'].resetFields();
                this.$refs['verifyForm'].resetFields();
                this.$refs['resetPwdForm'].resetFields();
            });
        },
        // 获取重置密码校验码
        async getCode(verfiyCode, vertifyCodeToken, account, successCall, errorCall) {
            let res = await this.axios.post(
                this.pub.getApi().RetrievePassword,
                {
                    account: account
                },
                {
                    params: {
                        'h-recaptcha': vertifyCodeToken,
                        'h-recaptchavalue': verfiyCode
                    }
                }
            );
            let { code, result, message } = res.data;
            // console.log(res);
            if (code === 0) {
                successCall();
            } else if (code === 101) {
                this.$message({
                    message: '驗證碼錯誤，請重新输入',
                    type: 'error',
                    showClose: true
                });
                errorCall();
                // 清空验证码输入框，刷新验证码
            } else if (code === 102) {
                this.$message({
                    message: '驗證碼不支持，請重新輸入',
                    type: 'error',
                    showClose: true
                });
                errorCall();
                // 清空验证码输入框，刷新验证码
            } else if (code === 103) {
                this.$message({
                    message: '驗證碼不存在，請重新輸入',
                    type: 'error',
                    showClose: true
                });
                errorCall();
                // 清空验证码输入框，刷新验证码
            } else if (code === 1321) {
                this.$message({
                    message: '賬戶不存在',
                    type: 'error',
                    showClose: true
                });
                errorCall();
            } else if (code === 1332) {
                this.$message({
                    message: '系統繁忙',
                    type: 'error',
                    showClose: true
                });
                errorCall();
            } else {
                this.$message({
                    message,
                    type: 'error',
                    showClose: true
                });
            }
        },
        // 忘記密碼 --確認賬戶
        confirmAccount() {
            // console.log(this.confirmForm.code);
            this.$refs['confirmForm'].validate(async valid => {
                if (valid) {
                    // console.log(this.confirmForm.vertifyCode);
                    this.getCode(
                        this.confirmForm.vertifyCode,
                        this.confirmForm.verfiyCodetoken,
                        this.confirmForm.account,
                        () => {
                            this.confirmFormVisible = false;
                            this.verifyFormVisible = true;
                            this.verifyForm.account = this.confirmForm.account;
                            // 重置验证弹框状态
                            this.$nextTick(() => {
                                // this.$refs["verifyForm"].resetFields();
                                this.countDown(true);
                            });
                        },
                        () => {
                            this.confirmForm.vertifyCode = '';
                            this.confirmCodeImgCilck();
                        }
                    );
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //確認賬戶弹框-- 点击图片获取验证码
        vertifyImgCilck() {
            this.LoadVertifyCode(({ image, token }) => {
                this.verifyForm.verfiyCodeImg = image;
                this.verifyForm.verfiyCodetoken = token;
            });
        },
        // 倒计时时间
        countDown(isFirst = false) {
            this.timeCount = 120;
            this.timeId = setInterval(() => {
                this.timeCount--;
                if (this.timeCount < 0) {
                    clearInterval(this.timeId); //清除定时器击
                    this.timeId = null;
                    this.isShow = true;
                    // 倒計時結束 刷新校驗碼
                    if (isFirst) return;
                    this.vertifyImgCilck();
                    this.verifyForm.vertifyCode = '';
                }
            }, 1000);
        },
        // 重新获取重置密码校验码
        getCodeAgain() {
            // 获取验证码
            this.getCode(
                this.verifyForm.vertifyCode,
                this.verifyForm.verfiyCodetoken,
                this.verifyForm.account,
                () => {
                    // this.timeCount = 120;
                    this.countDown();
                },
                () => {
                    this.vertifyImgCilck();
                    this.verifyForm.vertifyCode = '';
                }
            );
            // 倒计时开始
            // this.countDown();
        },
        // 忘記密碼 --校驗賬戶
        verifyAccount() {
            this.$refs['verifyForm'].validate(async valid => {
                if (valid) {
                    let res = await this.axios.post(this.pub.getApi().VerifyCodeToken, this.verifyForm);
                    // console.log("1", res);
                    let { code, message, result } = res.data;
                    if (code === 0) {
                        // console.log(1);
                        this.resetPwdForm.token = result;
                        this.verifyFormVisible = false;
                        this.resetPwdFormVisible = true;
                        // 重置验证弹框状态
                        // this.$nextTick(() => {
                        //   this.$refs["resetPwdForm"].resetFields();
                        // });
                    } else if (code === 101) {
                        this.$message({
                            message: '驗證碼錯誤，請重新輸入',
                            type: 'error',
                            showClose: true
                        });
                    } else {
                        this.$message({
                            message,
                            type: 'error',
                            showClose: true
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 忘記密碼 --重置密碼
        resetPwd() {
            this.$refs['resetPwdForm'].validate(async valid => {
                if (valid) {
                    let res = await this.axios.post(this.pub.getApi().UseTokenRetrievePassword, {
                        account: this.verifyForm.account,
                        password: this.resetPwdForm.confirmPwd,
                        token: this.resetPwdForm.token
                    });
                    // console.log(res);
                    let { code, message, result } = res.data;
                    if (code === 0) {
                        this.confirmAcountDialogVisible = false;
                        this.$message({
                            message: '密碼修改成功',
                            type: 'success',
                            showClose: true
                        });
                    } else {
                        this.$message({
                            message,
                            type: 'error',
                            showClose: true
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                this.vertifyImgCilck();
            }
        },
        confirmAcountDialogVisible(val) {
            // 弹框关闭，重置isShow, 清除定時器
            if (!val) {
                this.isShow = false;
                if (!this.timeId) return;
                clearInterval(this.timeId);
                this.timeId = null;
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../assets/css/element-reset.less';
.login-container {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 600px;
    position: relative;
    overflow: hidden;
    .login-backgroud {
        background: url(../assets/PMS_bg.jpg) no-repeat;
        background-size: cover;
        min-height: 500px;
        width: 100%;
        height: 80vh;
        margin-top: 6vh;
        position: relative;
    }
    p {
        font-size: 12px;
        color: #000000;
        line-height: 16px;
        margin-top: 20px;
    }
    .login-form {
        position: absolute;
        top: 50%;
        right: 110px;
        transform: translateY(-50%);
        width: 490px;
        margin: 0 auto;
        .logo {
            height: 62px;
            background: url(../assets/logo.svg) center no-repeat;
        }
        .el-form {
            background-color: #fff;
            margin-top: 25px;
            padding: 50px 60px 40px;
            box-shadow: 0 10px 49px 0 rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            box-shadow: 0 10px 49px 0 rgba(0, 0, 0, 0.1);
            .el-form-item {
                margin-bottom: 20px;
                .el-input {
                    height: 50px;
                }
                /deep/.el-input__inner {
                    height: 50px;
                    background: #fafafb;
                    border: 1px solid #f1f1f5;
                    border-radius: 15px;
                }
                .el-button {
                    width: 218px;
                    height: 60px;
                    border-radius: 10px;
                    font-size: 22px;
                    background-color: #304ffe;
                }
            }
            .el-form-item:last-child {
                margin-bottom: 0;
            }
            .login-btn {
                margin-top: 45px;
                .forget-passwd {
                    line-height: 1;
                    margin-top: 20px;
                    color: #0062ff;
                    span {
                        cursor: pointer;
                    }
                }
            }
            .suggestion {
                color: #ff2524;
            }
        }
    }
    .forget-pwd-dialog {
        text-align: left;
        background-color: rgba(196, 203, 216, 0.25);
        .el-form {
            .el-input {
                // height: 46px
                /deep/.el-input__inner {
                    width: 100%;
                    height: 46px;
                    border-radius: 15px;
                    background: #fafafb;
                    border: 1px solid #f1f1f5;
                }
                &.email-input {
                    width: 330px;
                }
                &.vertify-code-input {
                    width: 220px;
                }
            }
            .el-button {
                border-radius: 10px;
                width: 100px;
                height: 46px;
                margin-left: 10px;
                padding: 0;
                font-size: 16px;
            }
            .tips {
                width: 280px;
                margin-left: 155px;
            }
        }
        .el-col {
            padding-left: 0px !important;
            padding-right: 0px !important;
            line-height: 1;
        }
    }

    .code-img {
        width: 100%;
        height: 46px;
        margin-left: 15px;
    }
}
</style>
